// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionSteps_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/production_steps/salvar
 *
 * Create or update a production step.
 */
import { registerContract } from './validate'

export interface ProductionSteps_SalvarInput {
so_production_step_name: string
so_production_step_id?: number
so_production_step_qrcode?: string
so_production_step_description?: string
so_production_step_default_duration_minutes?: number
so_production_step_show_on_tv?: number
so_production_step_reset_exempt?: number
}

registerContract('ProductionSteps_SalvarInput', {
  so_production_step_name:                     { type: 'string',  required: true },
  so_production_step_id:                       { type: 'number',  required: false },
  so_production_step_qrcode:                   { type: 'string',  required: false },
  so_production_step_description:              { type: 'string',  required: false },
  so_production_step_default_duration_minutes: { type: 'number',  required: false },
  so_production_step_show_on_tv:               { type: 'number',  required: false },
  so_production_step_reset_exempt:             { type: 'number',  required: false },
})
